<template>
  <!-- After "Email me a sign-in link": the link is on its way. -->
  <div class="si-sent" data-test="link-sent" role="status">
    <span class="si-sent__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24"><path d="M22 2 11 13" /><path d="M22 2 15 22l-4-9-9-4z" /></svg>
    </span>
    <div>
      <p class="si-sent__title">{{ t("auth.identity.checkInbox") }}</p>
      <I18nT keypath="auth.identity.linkSentCard" tag="p" class="si-sent__body">
        <template #email><strong>{{ email }}</strong></template>
      </I18nT>
    </div>
    <button type="button" class="si-sent__back" data-test="link-sent-back" @click="$emit('back')">
      {{ t("auth.identity.otherWay") }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { I18nT, useI18n } from "vue-i18n";

export default defineComponent({
  name: "LinkSentCard",
  components: { I18nT },
  props: {
    email: { type: String, required: true },
  },
  emits: ["back"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style scoped>
.si-sent {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 16px;
  background: rgb(var(--v-theme-surface));
  border: 1px solid var(--sh-hairline);
}
.si-sent__icon {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(var(--v-theme-primary), 0.12);
}
.si-sent__icon svg {
  width: 24px;
  height: 24px;
  fill: none;
  stroke: rgb(var(--v-theme-primary));
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.si-sent__title {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 700;
}
.si-sent__body {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--sh-text-60);
  overflow-wrap: anywhere;
}
.si-sent__body strong {
  color: var(--sh-text);
}
.si-sent__back {
  align-self: flex-start;
  min-height: 44px;
  padding: 4px 0;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: rgb(var(--v-theme-primary));
  cursor: pointer;
}
.si-sent__back:hover {
  text-decoration: underline;
}
.si-sent__back:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}
</style>
